module.exports = __webpack_public_path__ + "img/xxhj_left_select.7bcf93a3.png";